module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Rapport de préconisation ")]), _c('br'), _vm._v(" "), _vm._l((_vm.preconizations), function(preconization, index) {
    return _c('div', [_c('h3', {
      class: {
        'mt-30': index != 0
      }
    }, [_vm._v(_vm._s(preconization.number) + ". " + _vm._s(preconization.title) + " ")]), _vm._v(" "), (preconization.description) ? _c('span', {
      staticClass: "ml-10 mt-10"
    }, [_vm._v(_vm._s(preconization.description)), _c('br')]) : _vm._e(), _vm._v(" "), _vm._l((preconization.actions), function(action) {
      return _c('div', [_c('h4', {
        staticClass: "ml-20"
      }, [_vm._v(_vm._s(action.number) + " " + _vm._s(action.title))]), _vm._v(" "), (action.description) ? _c('div', {
        staticClass: "ml-50 mt-10",
        domProps: {
          "innerHTML": _vm._s(_vm.getDescription(action.description))
        }
      }) : _vm._e(), _vm._v(" "), (action.deadline) ? _c('h5', {
        staticClass: "ml-50"
      }, [_vm._v("Délai de réalisation : " + _vm._s(action.deadline) + " ")]) : _vm._e()])
    })], 2)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df9cd0c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/others/report_preconization.vue
// module id = 127
// module chunks = 0